import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        name: null,     // 数据名称
        recordNo: null, // 数据名称
        auditType: null,  // 核验类型
      },
      // 查询旁边按钮
      searchList: [
        {
          name: "任务提醒",
          type: "success",
          icon: "timer"
        },
      ],
      // 查询表单
      formSearchList: [
        {
          label: "项目名称：",
          type: "input",
          value: "projectName",
          placeholder: "请输入",
        },
        {
          label: "数据编号：",
          type: "input",
          value: "recordNo",
          placeholder: "请输入",
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "projectName",
          isShow: true,
        },
        {
          label: "数据编号",
          prop: "recordNo",
        },
        {
          label: "核验类型",
          prop: "stepName",
        },      
        {
          label: "核验结果",
          prop: "auditResult",
        }, 
        {
          label: "核验意见",
          prop: "auditRemark",
        },      
        {
          label: "核验人员",
          prop: "auditUser",
        },      
        {
          label: "核验日期",
          prop: "auditDate",
        },  
      ],
      // 表格数据
      tableData: [],
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    this.form.auditType = this.$route.query.auditType;
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/auditLog/auditHistoryList", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查询按钮旁边按钮点击事件
     */
    fun_SearcClick(e){
      switch (e) {
        case "任务提醒":
          // 跳转到工作台
          this.$router.push({
            path: "/staffWorkbench",
            query: {}
          });
          break;
        default: 
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 详情信息
     */
    fun_Details(e){
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        historyType: "look",
        id: e.val.recordNo,
        auditId: e.val.auditId,
        auditType: e.val.auditType,
        otherTransactionFlag: e.val.otherTransactionFlag,
      }
      // 如果是项目登记
      if(this.form.auditType == "supConstruction"){
        // 跳转详情页面
        this.$router.push({ path: "/supConstructionAuditDetail", query: obj });
      }
      // 如果是招标登记
      else if(this.form.auditType == "biddingRegistration"){
        // 跳转详情页面
        this.$router.push({ path: "/biddingRegistrationAuditDetail", query: obj });
      }
      // 如果是直接发包备案
      else if(this.form.auditType == "contractRecordDirectly"){
        // 跳转详情页面
        this.$router.push({ path: "/contractRecordDirectlyAuditDetail", query: obj });
      }
      // 如果是项目经理总监表解锁申请
      else if(this.form.auditType == "projectManagerRecordUnlock"){
        // 跳转详情页面
        this.$router.push({ path: "/projectManagerUnlockAuditDetail", query: obj });
      }
      // 如果是项目经理总监表变更申请
      else if(this.form.auditType == "projectManagerRecordChange"){
        // 跳转详情页面
        this.$router.push({ path: "/projectManagerChangeAuditDetail", query: obj });
      }
      // 如果是直接发包项目经理总监表解锁申请
      else if(this.form.auditType == "contractRecordDirectlyUnlock"){
        // 跳转详情页面
        this.$router.push({ path: "/contractProjectManagerUnlockAuditDetail", query: obj });
      }
      // 如果是直接发包项目经理总监表解锁申请
      else if(this.form.auditType == "contractRecordDirectlyChange"){
        // 跳转详情页面
        this.$router.push({ path: "/contractProjectManagerChangeAuditDetail", query: obj });
      }
    },
  }
};
